import { useMediaQuery } from '@vueuse/core';

export { useMediaQuery };

const MediaQueries = {
  FROM_DESKTOP_MEDIUM: '(min-width: 1279px)',
  IS_DESKTOP_MEDIUM: '(max-width: 1279px)',
  IS_DESKTOP_SMALL: '(min-width: 1024px)',
  IS_DESKTOP: '(min-width: 1024px) and (max-width: 1279px)',
  IS_MOBILE: '(max-width: 767px)',
  IS_TABLET: '(max-width: 1023px)',
  IS_TABLET_MEDIUM: '(max-width: 987px)',
  IS_TABLET_ONLY: '(min-width: 768px) and (max-width: 1023px)',
} as const;

const isMobile = useMediaQuery(MediaQueries.IS_MOBILE);
const isTabletOnly = useMediaQuery(MediaQueries.IS_TABLET_ONLY);
const isTablet = useMediaQuery(MediaQueries.IS_TABLET);
const isTabletMedium = useMediaQuery(MediaQueries.IS_TABLET_MEDIUM);
const isDesktop = useMediaQuery(MediaQueries.IS_DESKTOP);

const isDesktopSmall = useMediaQuery(MediaQueries.IS_DESKTOP_SMALL);
const isDesktopMedium = useMediaQuery(MediaQueries.IS_DESKTOP_MEDIUM);
const fromDesktopMedium = useMediaQuery(MediaQueries.FROM_DESKTOP_MEDIUM);

export const useScreenSize = () => {
  return {
    fromDesktopMedium,
    isDesktopMedium,
    isDesktopSmall,
    isDesktop,
    isMobile,
    isTablet,
    isTabletMedium,
    isTabletOnly,
  };
};
